export const selectAllPreArrivalPreference = (state) =>
  state.preArrivalPreference.data;
